import { ConversationThread } from '@avanta/shared/components/Chat/ConversationThread';
import { InputChat } from '@avanta/shared/components/Chat/InputChat';
import { Header } from './components/Header';
import { WelcomeMessage } from './components/WelcomeMessage';

export const Conversation = (): React.ReactElement | null => (
  <ConversationThread
    className="rounded-lg"
    header={<Header />}
    welcome={<WelcomeMessage />}
    input={<InputChat />}
  />
);
